import styled, { keyframes } from 'vue3-styled-components';

// 애니메이션 정의
const modalSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const fadeIn = keyframes`
  from { 
    opacity: 0; 
    transform: translateY(10px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
`;

const rainbowBorder = keyframes`
  0% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
  14% { border-color: #ff7f00; box-shadow: 0 0 10px rgba(255, 127, 0, 0.7); }
  28% { border-color: #ffff00; box-shadow: 0 0 10px rgba(255, 255, 0, 0.7); }
  42% { border-color: #00ff00; box-shadow: 0 0 10px rgba(0, 255, 0, 0.7); }
  56% { border-color: #0000ff; box-shadow: 0 0 10px rgba(0, 0, 255, 0.7); }
  70% { border-color: #4b0082; box-shadow: 0 0 10px rgba(75, 0, 130, 0.7); }
  84% { border-color: #9400d3; box-shadow: 0 0 10px rgba(148, 0, 211, 0.7); }
  100% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
`;

const rainbowBackground = keyframes`
  0% { background-color: rgba(255, 0, 0, 0.05); }
  14% { background-color: rgba(255, 127, 0, 0.05); }
  28% { background-color: rgba(255, 255, 0, 0.05); }
  42% { background-color: rgba(0, 255, 0, 0.05); }
  56% { background-color: rgba(0, 0, 255, 0.05); }
  70% { background-color: rgba(75, 0, 130, 0.05); }
  84% { background-color: rgba(148, 0, 211, 0.05); }
  100% { background-color: rgba(255, 0, 0, 0.05); }
`;

// 스타일드 컴포넌트들
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 900px;
  height: 700px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: ${modalSlideIn} 0.3s ease-out;
  display: flex;
  flex-direction: column;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// * 체크박스 스타일
export const CustomCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #fb8b24;
  
  &:hover {
    transform: scale(1.1);
  }
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectAllLabel = styled.label`
  font-size: 11px;
  color: white;
  cursor: pointer;
  user-select: none;
`;

export const ModalHeader = styled.div`
  background: #fb8b24;
  color: white;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 35px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: red;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const LocationInfo = styled.div`
  margin-bottom: 24px;
`;

export const LocationBadge = styled.div`
  background: linear-gradient(135deg, #fb8b24, #ff9f3a);
  color: white;
  padding: 12px 16px;
  border-radius: 12px;
  display: inline-flex;
  gap: 8px;
`;

export const LocationLabel = styled.span`
  opacity: 0.9;
`;

export const LocationValue = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: #0f4c5c;
`;

export const TabContainer = styled.div`
  display: flex;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 24px;
`;

export const TabButton = styled.button`
  flex: 1;
  background: none;
  border: none;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  color: #6c757d;

  &.active {
    background: white;
    color: #0f4c5c;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const TabIcon = styled.span`
  font-size: 16px;
`;

export const TabContent = styled.div`
  animation: ${fadeIn} 0.3s ease-in;
`;

export const FormSection = styled.div`
  margin-bottom: 20px;
`;

export const SearchSection = styled.div`
  margin-bottom: 15px;
`;

export const ProductsSection = styled.div`
  margin-bottom: 15px;
`;

export const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const SectionTitle = styled.h3`
  color: #0f4c5c;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BarcodeScanStatusButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background-color: #0f4c5c;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  &.scanning {
    background-color: #fff;
    color: #0f4c5c;
    border: 2px solid #ff0000;
    animation: ${rainbowBorder} 2s linear infinite;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.1);
      z-index: -1;
      animation: ${rainbowBackground} 2s linear infinite;
    }

    &:hover {
      transform: translateY(-1px);
    }
  }

  .scan-icon {
    font-size: 16px;
  }

  .scan-text {
    font-weight: 600;
  }
`;

// 바코드 입력 필드 스타일 (스캔 중일 때 무지개 효과)
export const BarcodeFormInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }

  &.scanning {
    border-width: 2px;
    animation: ${rainbowBorder} 2s linear infinite;
    background-color: white;
    position: relative;

    &::placeholder {
      color: #9ca3af;
    }
  }

  &:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }
`;

export const BarcodeProductTableInput = styled.input`
  width: 90%;
  padding: 4px 6px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }

  &.scanning {
    border-width: 2px;
    animation: ${rainbowBorder} 2s linear infinite;
    background-color: white;
  }
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;

  &.full-width {
    grid-column: 1 / -1;
  }

  /* 선택된 이미지 그룹 전용 스타일 */
  &.selected-image-group {
    grid-column: 1 / -1; /* 그리드의 전체 너비 차지 */
    margin: 10px 0; /* 상하 여백 추가 */
  }
`;

export const FormLabel = styled.label`
  font-weight: 500;
  margin-bottom: 6px;
  font-size: 15px;

  &.required::after {
    content: ' *';
    color: red;
  }
`;

export const FormInput = styled.input`
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const FormStockInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const FormStockInput = styled.input`
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  transition: border-color 0.2s;
  min-width: 0;
  text-align: center;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const FormStockSeparator = styled.span`
  color: #6c757d;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
`;

export const FormSelect = styled.select`
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  font-size: 15px;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const SearchButton = styled.button`
  background: #fb8b24;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #e67e22;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 40px;
  color: #6c757d;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #fb8b24;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto 16px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #6c757d;
`;

export const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
`;

export const ProductCard = styled.div`
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  background: white;

  &:hover {
    border-color: #fb8b24;
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.1);
  }

  &.selected {
    border-color: #fb8b24;
    background: #fff8f0;
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.2);
  }
`;

export const ProductHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const ProductName = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  flex: 1;
`;

export const ProductBadge = styled.div`
  background: #ffc107;
  color: #856404;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
`;

export const ProductDetails = styled.div`
  margin-bottom: 12px;

  p {
    margin: 4px 0;
    font-size: 14px;
    color: #6c757d;
  }
`;

export const ProductFooter = styled.div`
  border-top: 1px solid #e9ecef;
  padding-top: 12px;
`;

export const QuantityInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const QuantityInput = styled.input`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 8px;
  width: 80px;
  font-size: 14px;
`;

export const ModalFooter = styled.div`
  background: #f8f9fa;
  padding: 20px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #e9ecef;
`;

export const CancelButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #6c757d;
  color: white;

  &:hover {
    background: #5a6268;
  }
`;

export const ConfirmButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #0f4c5c;
  color: white;

  &:hover:not(:disabled) {
    background: #1a7a8c;
  }

  &:disabled {
    background: #dee2e6;
    color: #6c757d;
    cursor: not-allowed;
  }
`;

// * 품목 테이블 스타일
export const ProductTable = styled.div`
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  background: white;
`;

export const ProductTableHeader = styled.div`
  display: grid;
  grid-template-columns: 30px 150px 150px 150px 180px 100px;
  background: #0f4c5c;
  color: white;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 8px;
  gap: 8px;
  align-items: center;
  text-align: center;
`;

export const ProductTableRow = styled.div`
  display: grid;
  grid-template-columns: 30px 150px 150px 150px 180px 100px;
  padding: 8px;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s;
  text-align: center;

  &:hover {
    background-color: #f8f9fa;
  }

  &.selected {
    background-color: #fff8f0;
    border-left: 4px solid #fb8b24;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ProductTableCell = styled.div`
  font-size: 14px;
  color: #495057;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProductTableInput = styled.input`
  width: 90%;
  padding: 4px 6px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const ProductTableSelect = styled.select`
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const ProductTableCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const ProductTableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`;

export const LocationInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const LocationInput = styled.input`
  flex: 1;
  padding: 4px 6px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  min-width: 0;
  text-align: center;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const LocationSeparator = styled.span`
  color: #6c757d;
  font-weight: bold;
  font-size: 12px;
  flex-shrink: 0;
`;

// * 바코드 스캐너 관련 스타일
export const BarcodeInputContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ScannerButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #fb8b24;
  background: white;
  color: #fb8b24;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    background: #fb8b24;
    color: white;
  }

  &.active {
    background: #fb8b24;
    color: white;
    animation: ${pulse} 1.5s infinite;
  }

  &:disabled {
    background: #f8f9fa;
    color: #6c757d;
    border-color: #dee2e6;
    cursor: not-allowed;
  }
`;

export const ScannerButtonSmall = styled.button`
  padding: 4px 6px;
  border: 1px solid #fb8b24;
  background: white;
  color: #fb8b24;
  border-radius: 3px;
  cursor: pointer;
  font-size: 10px;
  transition: all 0.2s;

  &:hover {
    background: #fb8b24;
    color: white;
  }

  &.active {
    background: #fb8b24;
    color: white;
    animation: ${pulse} 1.5s infinite;
  }

  &:disabled {
    background: #f8f9fa;
    color: #6c757d;
    border-color: #dee2e6;
    cursor: not-allowed;
  }
`;

export const BarcodeTableInputContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

// * 이미지 검색 관련 스타일
export const ProductNameInputContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ImageSearchButton = styled.button`
  padding: 6px 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 30px;
  height: 40px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SelectedImageContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 20px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    border-color: #667eea;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.1);
  }
`;

export const SelectedImagePreview = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const SelectedImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  border: 2px solid #dee2e6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const ImageLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 12px;
  color: #667eea;
  font-weight: 500;
`;

export const SelectedImageInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const SelectedImageTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  margin-bottom: 4px;
`;

export const SelectedImageSize = styled.div`
  font-size: 0.9rem;
  color: #667eea;
  font-weight: 500;
`;

export const SelectedImageUrl = styled.div`
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 8px;
`;

export const ImageActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
`;

export const RemoveImageButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
  }
`;

// * 반응형 미디어 쿼리
export const ResponsiveModalContainer = styled(ModalContainer)`
  @media (max-width: 1024px) {
    width: 800px;
    height: 650px;
  }
  
  @media (max-width: 768px) {
    width: 95vw;
    height: 85vh;
    max-width: 600px;
    max-height: 700px;
  }
  
  @media (max-width: 480px) {
    width: 95vw;
    height: 90vh;
    max-width: 400px;
  }
`;

export const ResponsiveFormGrid = styled(FormGrid)`
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ResponsiveProductsGrid = styled(ProductsGrid)`
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ResponsiveModalHeader = styled(ModalHeader)`
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const ResponsiveModalTitle = styled(ModalTitle)`
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const ResponsiveModalBody = styled(ModalBody)`
  @media (max-width: 768px) {
    padding: 20px;
  }
`;